import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { SheetGeometry, SheetGeometryList } from "building-types/views/sheetGeometryTypes";
import { sheetAddGeometries, sheetTextGeometryNew } from "building-types/views/sheetGeometryTypes";
import { assertIsNotUndefined } from "common/utils/assertOfType";
import type { Label } from "lib/house/plans/label";

export function planAddLabels(list: SheetGeometryList, props: PlanLabelProps) {
  return sheetAddGeometries(list, makeSheetGeometryFromLabels(props));
}

interface PlanLabelProps {
  handle: DocEntityHandle;
  labels: Label[];
  noSettings?: boolean;
}

export function makeSheetGeometryFromLabels(props: PlanLabelProps): SheetGeometry[] {
  const sheetGeometry: SheetGeometry[] = [];

  const { handle, labels, noSettings } = props;
  for (let i = 0; i < labels.length; i++) {
    const l = labels[i];
    const {
      text: label,
      centerX: x,
      centerY: y,
      textRotationRads,
      textRotationBasis,
      fontSize,
      relaxationRangeAABB,
      relaxationNormalX = 0,
      relaxationNormalY = 0,
      handle: labelHandle,
    } = l;

    assertIsNotUndefined(x);
    assertIsNotUndefined(y);

    sheetGeometry.push(
      sheetTextGeometryNew({
        handle: labelHandle ?? handle,
        text: label,
        fontSize: noSettings ? undefined : fontSize,
        x,
        y,
        rotation: textRotationRads,
        rotationBasis: textRotationBasis,
        relaxationRangeAABB,
        relaxationNormalX,
        relaxationNormalY,
      }),
    );
  }

  return sheetGeometry;
}
